// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f16537cb","497":"f997a622","502":"2f91c2c1"}[chunkId] + ".chunk.js";
};